module.exports = __webpack_public_path__ + "static/media/수리봉.af33d016.jpg";